<template>
  <div class="horizontal-layout page-header-light horizontal-menu 1-column forgot-bg blank-page blank-page" data-open="click" data-menu="horizontal-menu" data-col="1-column">
    <div class="row">
      <div class="col s12">
        <div class="container">
          <div id="forgot-password" class="row">
            <div class="col s12 m6 l4 z-depth-4 offset-m4 card-panel border-radius-6 forgot-card">
              <form class="change-form">
                <div class="row">
                  <div class="input-field col s12">
                    <h5 class="ml-4">Change Password</h5>
                    <!-- <p class="ml-4">You can change your password</p> -->
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <!-- <i class="material-icons prefix pt-2">lock</i> -->
                    <input maxlength="15" @keyup="errorMessage=''" v-model="old_password" id="old_password" name="old_password" type="password">
                    <label for="old_password" class="center-align">Old Password</label>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <!-- <i class="material-icons prefix pt-2">lock_outline</i> -->
                    <input maxlength="15" @keyup="errorMessage=''" v-model="new_password" id="new_password" name="new_password" type="password">
                    <label for="new_password">New Password</label>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <!-- <i class="material-icons prefix pt-2">lock_outline</i> -->
                    <input maxlength="15" @keyup="errorMessage=''" id="confirm_password" name="confirm_password" type="password">
                    <label for="password">Confirm Password</label>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <span class="error-message text-center" v-if="showErrMsg">{{errorMessage}}</span>
                    <button v-loader-button="isLoading" type="submit" name="action" class="btn waves-effect waves-light border-round gradient-45deg-purple-deep-orange col s12 mb-1">Change Password</button>
                  </div>
                </div>
                <div class="row mar">
                  <div class="input-field col s12 m12 l12">
                    <p class="margin medium-small right-align" @click="$router.push({path:'/app/dashboard'})">
                      <a class="pointer">Back to Dashboard ?</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        old_password: "",
        new_password: "",
        isLoading: false,
        showErrMsg: false,
        errorMessage: ""
      };
    },
    created() {
      setTimeout(() => {
        let jsArray = [
          "/assets/vendors/jquery-validation/jquery.validate.min.js"
        ];
        Vue.loadJs(jsArray);
      }, 200);
      this.initJs();
    },
    methods: {
      initJs() {
        // this.$router.push({path: '/app/dashboard'});
        setTimeout(() => {
          $(() => {
            $(".change-form").validate({
              rules: {
                old_password: {
                  required: true,
                  minlength: 6
                },
                new_password: {
                  required: true,
                  minlength: 6
                },
                confirm_password: {
                  required: true,
                  minlength: 6,
                  equalTo: "#new_password"
                }
              },
              //For custom messages
              messages: {
                old_password: {
                  minlength: "Please enter at least 6 characters"
                },
  
                new_password: {
                  minlength: "Please enter at least 6 characters"
                },
                confirm_password: {
                  minlength: "Please enter at least 6 characters",
                  equalTo: "Passwords does not match"
                }
              },
              errorElement: "div",
              errorPlacement: function(error, element) {
                var placement = $(element).data("error");
                if (placement) {
                  $(placement).append(error);
                } else {
                  error.insertAfter(element);
                }
              },
              submitHandler: e => {
                 $('button').attr('disabled','disabled');
                 setTimeout(() =>{
                  $('button').removeAttr('disabled');
                 },500);
                this.onChangePassword();
                return false;
              }
            });
          });
        }, 500);
      },
      onChangePassword() {
        this.isLoading = true;
        let params = {
          current_password: this.old_password,
          new_password: this.new_password
        };
        this.showErrMsg = false;
        ajax.post(
          Constants.default.APIURL.ChangePassword,
          params,
          res => {
            this.isLoading = false;
            this.$router.push({
              path: "/app/dashboard"
            });
          },
          err => {
            this.showErrMsg = true;
            this.isLoading = false;
            if (err.data.non_field_errors) {
              this.errorMessage = err.data.non_field_errors[0];
            } else {
              if (Object.keys(err.data).length > 0) {
                this.errorMessage = err.data[Object.keys(err.data)[0]][0];
              }
            }
            this.errorMessage = this.errorMessage ? this.errorMessage : 'Something went wrong.';
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
  .margin {
    margin-left: -2px !important;
  }
  
  @import "./../../public/assets/css/pages/forgot.css";
</style>
